<div class="p500-ui-form-field">
  <p500-ui-select-with-icon-field
    [ngModel]="selectedData"
    [data]="data"
    [readonly]="readonly"
    [label]="label"
    (ngModelChange)="handleChange($event)"
  >
  </p500-ui-select-with-icon-field>
  <div *ngIf="control.getError('customValidate')" class="err-msg-tooltip">
    {{ control.getError('customValidate') }}
  </div>
</div>
